import { useState, useCallback } from 'react';

export const useDeleteConfirmation = (
  onConfirmDefault,
  defaultMessage = 'Tem certeza que deseja excluir este item?',
) => {
  const [isOpen, setIsOpen] = useState(false);
  const [onConfirm, setOnConfirm] = useState(() => () => {});
  const [message, setMessage] = useState(defaultMessage);

  const open = useCallback(
    (confirmFn, customMessage) => {
      setOnConfirm(() => confirmFn || onConfirmDefault);
      setMessage(customMessage || defaultMessage);
      setIsOpen(true);
    },
    [onConfirmDefault, defaultMessage],
  );

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const confirm = useCallback(() => {
    onConfirm();
    close();
  }, [onConfirm, close]);

  return {
    isOpen,
    message,
    open,
    close,
    confirm,
  };
};
